import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import { authCookies } from "@/services/cookies";

export const AppAbility = createMongoAbility;

export const parsePermission = (permission) => {
  if (typeof permission !== "string" || !permission.includes(".")) {
    return { action: permission, subject: "all" };
  }

  const parts = permission.split(".");
  const action = parts.pop();
  const subject = parts.join(".");

  return { action, subject };
};

export const defineAbilityFor = (permissions = []) => {
  const { can, build } = new AbilityBuilder(AppAbility);

  if (!Array.isArray(permissions)) {
    return build();
  }

  permissions.forEach((permission) => {
    if (typeof permission !== "string" || !permission) return;
    const { action, subject } = parsePermission(permission);
    can(action, subject);
  });

  return build();
};

export const ability = defineAbilityFor(authCookies.getPermissions());

export const updateAbility = (permissions = []) => {
  const nextAbility = defineAbilityFor(permissions);
  ability.update(nextAbility.rules);
  return ability;
};

export const resetAbility = () => updateAbility([]);

export const canPermission = (permission) => {
  if (permission === true) return true;
  if (!permission) return false;

  if (typeof permission === "object" && permission.action) {
    return ability.can(permission.action, permission.subject || "all");
  }

  if (typeof permission !== "string") return false;

  const { action, subject } = parsePermission(permission);
  return ability.can(action, subject);
};

export const canAnyPermission = (permissions = []) => {
  if (!Array.isArray(permissions) || !permissions.length) return true;
  return permissions.some((permission) => canPermission(permission));
};
